import GenericReportSettingsPage from './GenericReportSettingsPage';
import { BaseReportSettingsPageProps } from './types';

export default function TimeTriggerReportSettingsPage(props: BaseReportSettingsPageProps) {
  return <GenericReportSettingsPage {...props} description="This report has no settings." />;
}
